






































































































import { Vue, Component } from "vue-property-decorator";
import loading from "@/components/loader/loading.vue";
import { FavoriteCategory } from "@/api";
import { selfData } from "@/common/role_utils";
import FavoriteCategoryForm from "./FavoriteCategoryForm.vue";

@Component({
  components: {
    loading,
    FavoriteCategoryForm,
  },
})
export default class FavoriteCategoryList extends Vue {
  isDataLoading = false;
  selectedCategory: FavoriteCategory = {
    id: 0,
    category: "",
    companyId: selfData().companyId,
  };
  counter = 0;
  categoryFormToggle = false;
  action = "addFavoriteCategory";

  async created() {
    this.isDataLoading = true;
    await this.$store.dispatch("favoriteCategory/fetchFavoriteCategories");
    this.isDataLoading = false;
  }

  get favoriteCategories() {
    const list = this.$store.getters["favoriteCategory/favoriteCategories"];
    return list || [];
  }

  back() {
    this.$router.back();
  }

  async deleteFavoriteCategory(category: FavoriteCategory) {
    await this.$store.dispatch(
      "favoriteCategory/deleteFavoriteCategory",
      category,
    );
  }

  clearSelectedCategory() {
    this.selectedCategory = {
      id: 0,
      category: "",
      companyId: selfData().companyId,
    };
  }

  updateCategory(category: FavoriteCategory) {
    this.counter++;
    this.selectedCategory = category;
    this.action = "updateFavoriteCategory";
    this.categoryFormToggle = !this.categoryFormToggle;
  }

  addFavoriteCategory() {
    this.counter++;
    this.clearSelectedCategory();
    this.action = "addFavoriteCategory";
    this.categoryFormToggle = !this.categoryFormToggle;
  }
}
